module.exports = __webpack_public_path__ + "img/blue.24b00232.png";